<template>
    <div class="DdrDynamicFormBanner">
        <div class="DdrDynamicFormBanner__iconAndText">
            <EidIcon :icon-src="faSparkles" />
            <div class="DdrDynamicFormBanner__text">
                <span>AI successfully extracted</span>
                <span class="text-eidTrustGreen"> {{ aiFieldsCount }} fields</span>
                <span>, each verified with high confidence for accuracy.</span>
            </div>
        </div>
        <NewButton
            variant="outline"
            color="primary"
            @click="toggleAiFieldsDisplay"
        >
            {{ buttonText }}
        </NewButton>
    </div>
</template>

<style lang="scss">
    .DdrDynamicFormBanner {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        background-color: var(--eidTrustGreen-10);
        border: 1px solid var(--eidTrustGreen-50);
        padding: 8px 16px;
        border-radius: 12px;

        &__iconAndText {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .EidIcon {
            color: var(--eidTrustGreen);
        }
    }
</style>
<script lang="ts">
    import { defineComponent } from 'vue';

    import { faSparkles } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'DdrDynamicFormBanner',
        components: {
            NewButton,
            EidIcon,
        },
        props: {
            showAiFields: {
                type: Boolean,
                default: false,
            },
            aiFieldsCount: {
                type: Number,
                default: 0,
            },
        },
        emits: [ 'update-ai-fields-visibility' ],
        data() {
            return {
                faSparkles,
            };
        },
        computed: {
            buttonText(): string {
                return this.showAiFields ? 'Hide Fields' : 'Show Fields';
            },
        },
        methods: {
            toggleAiFieldsDisplay() {
                this.$emit('update-ai-fields-visibility', !this.showAiFields);
            },
        },
    });
</script>
